import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'

const WelcomeLast = () => {
  return (
    // <>
    //   <Text
    //     style={{
    //       fontWeight: 'bold',
    //       fontSize: 27,
    //       color: 'white',
    //       alignSelf: 'center'
    //     }}
    //   >
    //     Even More...
    //   </Text>

    //   <Text
    //     style={{
    //       fontSize: 17,
    //       color: 'white',
    //       alignSelf: 'center',
    //       marginTop: '5%'
    //     }}
    //   >
    //     You can update personal
    //   </Text>
    //   <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     information, swap shifts, and more!
    //   </Text>
    //   {/* <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     You can also update personal
    //   </Text> */}

    //   <View style={[styles.rectangle]}>
    //     <Image
    //       source={require('../../../static/images/Welcome-Evenmore.png')}
    //       style={[styles.appBrand]}
    //       resizeMode="contain"
    //     />
    //   </View>
    // </>
    <>
      <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      >
        Even More...
      </Text>
      <Text
        style={{
          fontSize: 17,
          color: 'white',
          alignSelf: 'center',

        }}
      >
        You can update personal information,{"\n"}swap shifts, and more!
      </Text>



      <Image
        source={require('../../../static/images/Welcome-Labour.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />
    </>
  )
}

export default WelcomeLast

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    //backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center',
    marginBottom: '5%'
    // marginTop:'10%'
  }
})
